<template>
  <div>Not implemented editor {{ field.field_type }}</div>
</template>

<script>
import formsMixin from '../formsMixin';

export default {
  mixins: [formsMixin],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
};
</script>
